import { Form, Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const QASection = ({ data, qaAnswers, setFormData, errors, locale }) => {
  const handleChange = (questionId, value) => {
    setFormData((prev) => ({
      ...prev,
      qaAnswers: {
        ...prev.qaAnswers,
        [questionId]: {
          ...prev.qaAnswers?.[questionId],
          value,
        },
      },
    }));
  };

  return (
    <Row>
      <Col lg={8} xl={7} className="qa-section">
        {data?.sort((a, b) => a.admg_order - b.admg_order)
          .map((group) => (
            <div key={group.admg_id} className="mb-5">
              <h5 className="mb-3">{locale === "en" ? group.admg_title : group.admg_title_ar}</h5>

              {group?.admission_questions?.map((question) => (
                <div key={question.adm_quest_id} className="mb-4">
                  <Form.Label>
                    {locale === "en" ? question.adm_desc : question.adm_desc_ar}{" "}
                    {question.adm_mandatory === 1 && (
                      <span className="text-danger">*</span>
                    )}
                  </Form.Label>

                  {question.adm_tf === 1 ? (
                    <>
                      <Row className="mb-2">
                        <Col xs={"auto"}>
                          <Form.Check
                            type="radio"
                            label={locale === "en" ? "True" : "صحيح"}
                            name={`q_${question.adm_quest_id}`}
                            id={`q_${question.adm_quest_id}_true`}
                            onChange={() =>
                              handleChange(question.adm_quest_id, 1)
                            }
                            checked={
                              qaAnswers[question.adm_quest_id]?.value == 1
                            }
                          />
                        </Col>
                        <Col xs={"auto"}>
                          <Form.Check
                            type="radio"
                            label={locale === "en" ? "False" : "خطأ"}
                            name={`q_${question.adm_quest_id}`}
                            id={`q_${question.adm_quest_id}_false`}
                            onChange={() =>
                              handleChange(question.adm_quest_id, 0)
                            }
                            checked={
                              qaAnswers[question.adm_quest_id]?.value == 0
                            }
                          />
                        </Col>
                      </Row>

                      {/* Optional comment box for True/False */}
                      <Form.Control
                        as="textarea"
                        rows={2}
                        className="mt-2"
                        placeholder={locale === "en" ? "Add comment (optional)" : "أضف تعليق (اختياري)"}
                        value={qaAnswers[question.adm_quest_id]?.comment || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            qaAnswers: {
                              ...prev.qaAnswers,
                              [question.adm_quest_id]: {
                                ...prev.qaAnswers?.[question.adm_quest_id],
                                comment: e.target.value,
                              },
                            },
                          }))
                        }
                      />
                    </>
                  ) : (
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Enter your answer"
                      value={qaAnswers[question.adm_quest_id]?.value || ""}
                      onChange={(e) =>
                        handleChange(question.adm_quest_id, e.target.value)
                      }
                    />
                  )}

                  {errors[`qa_${question.adm_quest_id}`] && (
                    <Form.Text className="text-danger">
                      <FormattedMessage id="error.qa" />
                    </Form.Text>
                  )}
                </div>
              ))}
            </div>
          ))}
      </Col>
    </Row>
  );
};

export default QASection;
